// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".folder-tree > .customCardbody {\n  padding-bottom: 15px !important;\n  margin-top: 0px !important;\n  margin-bottom: 20px !important;\n}\n.context-title {\n  background-color: #e9e9e9;\n}", ""]);
// Exports
module.exports = exports;
